var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83691 19.3398C6.20605 19.3398 6.4873 19.1641 6.92676 18.7598L9.41406 16.4746C8.92188 16.0791 8.5 15.4111 8.5 14.0488V7.86133C8.5 5.09277 10.1963 3.43164 12.9648 3.43164H19.293L19.2842 3.15918C19.126 1.41016 17.9658 0.232422 15.874 0.232422H3.65723C1.54785 0.232422 0.220703 1.46289 0.220703 3.60742V12.4141C0.220703 14.5322 1.52148 15.833 3.5957 15.833H5.00195V18.3818C5.00195 18.9619 5.30957 19.3398 5.83691 19.3398ZM20.6465 20.6055C21.1826 20.6055 21.4902 20.2275 21.4902 19.6475V17.0986H22.3955C24.4697 17.0986 25.7705 15.7979 25.7705 13.6797V8.08984C25.7705 5.94531 24.4434 4.71484 22.334 4.71484H13.2285C11.04 4.71484 9.79199 5.93652 9.79199 8.125V13.6797C9.79199 15.8154 11.0488 17.0986 13.2285 17.0986H16.3223L19.5654 20.0254C20.0049 20.4297 20.2773 20.6055 20.6465 20.6055Z",
    fill: "#5D820E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentGreen);
export default __webpack_public_path__ + "static/media/comment_green.1cf3338d230b5f2ca62d760c5b4c563d.svg";
export { ForwardRef as ReactComponent };